import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Div from '../Page/Div';
import { sanitize } from '../../utils';
const BlogSection = ({ content, idx, allowOpen }) => {
    const { title, content: pageContent } = content ?? {};
    return (_jsxs("div", { className: "blog-container", children: [_jsx(Div, { className: "blog-title", delay: 0, noScale: true, children: _jsx("h1", { className: "blog-title-wrapper", dangerouslySetInnerHTML: {
                        __html: sanitize(title?.rendered ?? ''),
                    } }) }), _jsx(Div, { className: "blog-content legals-content", delay: 1, noScale: true, children: _jsx("div", { className: "blog-content-wrapper legals-content-wrapper", dangerouslySetInnerHTML: {
                        __html: sanitize(pageContent?.rendered ?? ''),
                    } }) })] }));
};
export default BlogSection;
